<template>
  <v-dialog v-model="dialogopen" width="560" persistent>
    <v-card>
      <v-card-text v-if="input">
        <div class="form-control" :class="{ 'has-error': errors.has('name') }">
          <label>Name</label>
          <input
            v-model="input.name"
            name="name"
            v-validate="`required|excluded:${nameExist}`"
            :data-vv-as="$t('Name')"
            type="text"
          />
          <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('salesforce_email') }">
          <label>Salesforce Email</label>
          <input
            v-model="input.salesforce_email"
            name="salesforce_email"
            v-validate="`required`"
            :data-vv-as="$t('Salesforce Email')"
            type="text"
          />
          <span class="text-error" v-if="errors.has('salesforce_email')">{{
            errors.first('salesforce_email')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('Project Interest Code') }">
          <label>Project Interest Code</label>
          <input
            v-model="input.projectinterest_code"
            name="Project Interest Code"
            v-validate="`required`"
            :data-vv-as="$t('Project Interest Code')"
            type="text"
          />
          <span class="text-error" v-if="errors.has('Project Interest Code')">{{
            errors.first('Project Interest Code')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('LeadCampaign') }">
          <label>LeadCampaign</label>
          <input
            v-model="input.leadcampaign"
            name="LeadCampaign"
            :data-vv-as="$t('LeadCampaign')"
            type="text"
          />
          <span class="text-error" v-if="errors.has('LeadCampaign')">{{
            errors.first('LeadCampaign')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('type') }">
          <label>Type</label>
          <v-radio-group
            v-model="input.type"
            name="type"
            v-validate="'required'"
            :data-vv-as="$t('Type')"
            row
            style="margin-top: 5px"
            class="ananda"
          >
            <v-layout style="width: 100%">
              <v-flex sm6>
                <v-radio color="primary" label="Property" value="property"></v-radio>
              </v-flex>
              <v-flex sm6>
                <v-radio color="primary" label="Event" value="event"></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
          <span class="text-error" v-if="errors.has('type')">{{ errors.first('type') }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('saleforce') }">
          <label>Save Saleforce Type</label>
          <v-radio-group
            v-model="input.salesforce"
            name="saleforce"
            v-validate="'required'"
            :data-vv-as="$t('Saleforce')"
            row
            style="margin-top: 5px"
            class="ananda"
          >
            <v-layout style="width: 100%">
              <v-flex sm6>
                <v-radio color="primary" label="Yes" :value="true"></v-radio>
              </v-flex>
              <v-flex sm6>
                <v-radio color="primary" label="No" :value="false"></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
          <span class="text-error" v-if="errors.has('saleforce')">{{
            errors.first('saleforce')
          }}</span>
        </div>
        <div grid-list-md>
          <v-layout row wrap>
            <v-flex
              sm6
              style="padding-right: 10px"
              class="form-control"
              :class="{ 'has-error': errors.has('Photo') }"
            >
              <label>Upload Cover (1000px x 500px)</label>

              <uploadfile
                v-if="dialogopen"
                v-model="input.photo"
                name="Photo"
                v-validate="'required'"
                :data-vv-as="$t('Photo')"
                :height="250"
              ></uploadfile>
              <span class="text-error" v-if="errors.has('Photo')">{{ errors.first('Photo') }}</span>
            </v-flex>
            <v-flex sm6 class="form-control" :class="{ 'has-error': errors.has('bgPhoto') }">
              <label>Background</label>
              <div class="wheel" id="colorWheel"></div>

              <span class="text-error" v-if="errors.has('bgPhoto')">{{
                errors.first('bgPhoto')
              }}</span>
            </v-flex>
          </v-layout>
        </div>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" color="grey" outline>{{ $t('cancel') }}</v-btn>
          <v-btn
            @click="submitData"
            color="primary"
            depressed
            :loading="loading"
            :disabled="loading"
            >{{ input.id ? $t('update') : $t('save') }}</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadvideo'
import iro from '@jaames/iro'

const dict = {
  en: {
    custom: {
      name: {
        excluded: 'Duplicate Name',
        excludednew: 'Duplicate Name'
      }
    }
  },
  th: {
    custom: {
      name: {
        excluded: 'ชื่อโครงการซ้ำ',
        excludednew: 'ชื่อโครงการซ้ำ'
      }
    }
  }
}

export default {
  props: {
    dialogopen: {
      default: false
    },
    inputx: {
      default: {
        name: '',
        photo: '',
        type: '',
        salesforce: '',
        salesforce_email: '',
        background: '',
        projectinterest_code: '',
        leadcampaign: ''
      }
    },
    showname: {
      default: []
    }
  },
  data() {
    return {
      loading: false,
      input: [],
      color: '',
      colorWheel: ''
    }
  },
  components: {
    uploadfile
  },
  computed: {
    nameExist() {
      return this.showname.map((el) => el.name)
    }
  },
  mounted() {
    var vm = this
    vm.$validator.localize(dict)
    this.colorWheel = new iro.ColorPicker('#colorWheel', {
      width: 200,
      height: 150,
      color: 'rgb(255, 255, 255)',
      borderWidth: 1,
      borderColor: '#fff'
    })
    this.colorWheel.on(['color:init', 'color:change'], function (color) {
      vm.input.background = color.hexString
    })
  },
  methods: {
    submitData() {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          return false
        }

        if (this.input.id) this.updateData()
        else this.saveData()
      })
    },
    saveData() {
      var vm = this
      vm.loading = true
      var data = { input: this.input }
      api.postanandaregisterliffurl(data, (error, response) => {
        if (response.responsecode == 200) {
          vm.loading = false
          vm.$emit('saveData', response.data)
        }
      })
    },
    updateData() {
      var vm = this
      vm.loading = true
      api.putanandaregisterliffurl(this.input, (error, response) => {
        if (response.responsecode == 200) {
          vm.loading = false
          vm.$emit('updateData', response.data)
        }
      })
    }
  },
  watch: {
    dialogopen(val, oldval) {
      this.input = { ...this.inputx }
      this.colorWheel.color.hexString = this.inputx.background
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    }
  }
}
</script>

<style>
.ananda .v-input__control {
  width: 100% !important;
}
.IroWheel,
.IroSlider {
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/Forminput.vue